import { useTranslation } from 'react-i18next';

import styles from './AlertsEmptyState.module.scss';

export const AlertsEmptyState = () => {
  const { t } = useTranslation('alerts', { useSuspense: false });

  return (
    <div className={styles.root}>
      <img
        src="/app/static/images/empty-state/radio-telescope.png"
        width={160}
        height={160}
        alt=""
      />
      <div className={styles.textWrapper}>
        <div className={styles.title}>{t('alerts:emptyState.title')}</div>
      </div>
    </div>
  );
};
